import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import PdfStore from '../../../stores/PdfStore'
import WorkdocStore from '../../../stores/WorkdocStore'
import FontAwesome from 'react-fontawesome'
import './Print.css'

const checkList = [
  {label:'ไฟหน้า',value:undefined},
  {label:'ไฟเลี้ยว',value:undefined},
  {label:'ไฟท้าย',value:undefined},
  {label:'แตร',value:undefined},
  {label:'ปัดน้ำฝน',value:undefined},
  {label:'ฉีดน้ำฝน',value:undefined},
  {label:'ละออง',value:undefined},
  {label:'แบตเตอรี่',value:undefined},
  {label:'น้ำหม้อน้ำ',value:undefined},
  {label:'น้ำหม้อพัก',value:undefined},
  {label:'นำ้มันเครื่อง',value:undefined},
  {label:'น้ำมันเบรค',value:undefined},
  {label:'ลองเบรค',value:undefined},
  {label:'ฟังเสียงเครื่องยนต์',value:undefined},
  {label:'เข็มวัดรอบความร้อน',value:undefined},
  {label:'หลักกิโล',value:undefined},
  {label:'ล้างรถ',value:undefined},
  {label:'เปิด-ปิด ประตู',value:undefined},
  {label:'สีไม่เงา',value:undefined},
  {label:'อะไหล่',value:undefined}
]
const checkList2 = [
  {label:'แผ่นเพรส',value:undefined},
  {label:'ยางอะไหล่',value:undefined},
  {label:'ร่องต่างๆ',value:undefined},
  {label:'วิทยุ',value:undefined},
  {label:'ฟิล์ม',value:undefined},
  {label:'แอร์',value:undefined},
  {label:'ตั้งศูนย์',value:undefined},
  {label:'ป้ายวงกลม',value:undefined},
  {label:'ของฝากลูกค้า',value:undefined},
  {label:'ป้ายทะเบียน',value:undefined},
  {label:'ดูดฝุ่น',value:undefined},
  {label:'พวงมาลัยพาวเวอร์',value:undefined},
  {label:'ลมยาง',value:undefined},
  {label:'ผ้ารองพื้น',value:undefined},
  {label:'ขันน็อตล้อ',value:undefined},
  {label:'เบาะ เชื้อรา',value:undefined},
  {label:'สีเพี้ยน',value:undefined},
  {label:'อะไหล่ไม่เข้ารูป',value:undefined},
  {label:'อะไหล่ไม่แน่น',value:undefined},
  {label:'ลมเข้า',value:undefined},
  {label:'น้ำเข้า',value:undefined},
  {label:'ทดลองขับ',value:undefined},
]
var NotificationSystem = require('react-notification-system');
class PrintSSTWorkQCDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {
        loading:false,
        data:{
          related_detail:{
            checkList:checkList,
            checkList2:checkList2
          }  
        },
        page_title:'กำลังดึงข้อมูล..'
    }

    var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
    }());
  
    cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData()
  }

  loadData() {
    PdfStore.loadDelivercarDoc(this.props.workNo,this.props.dn,(result)=>{
      result.data.related_detail = Object.assign({checkList:checkList,checkList2:checkList2}, result.data.related_detail)
      this.setState({data:result.data})
    },()=>{

    })
  }

  saveWorkdocRelated() {
    let {workNo} = this.props
    let {data} = this.state
    let postData = {checkList:data.related_detail.checkList,checkList2:data.related_detail.checkList2}
    WorkdocStore.saveWorkdocRelated(this.props.workNo,this.props.dn,postData,(result)=>{
      if (result.status=='OK') {
        this._notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
          level: 'info',
          position: 'tc',        
        });
      }
    },()=>{
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      });
    })
  }

  oncheckListClick(index,value) {
    let {checkList} = this.state.data.related_detail
    if (value) {
      if (checkList[index].value==undefined)
        checkList[index].value = true
      else if (!checkList[index].value)  
        checkList[index].value = true
      else
        checkList[index].value = undefined
    } else {
      if (checkList[index].value==undefined)
        checkList[index].value = false
      else if (checkList[index].value)  
        checkList[index].value = false  
      else
        checkList[index].value = undefined
    }
    this.setState({checkList:checkList})
    this.saveWorkdocRelated()
  }

  oncheckListClick2(index,value) {
    let {checkList2} = this.state.data.related_detail
    if (value) {
      if (checkList2[index].value==undefined)
        checkList2[index].value = true
      else if (!checkList2[index].value)  
        checkList2[index].value = true
      else
        checkList2[index].value = undefined
    } else {
      if (checkList2[index].value==undefined)
        checkList2[index].value = false
      else if (checkList2[index].value)  
        checkList2[index].value = false  
      else
        checkList2[index].value = undefined
    }
    this.setState({checkList2:checkList2})
    this.saveWorkdocRelated()
  }

  renderSignature2() {
    return(
            <div className='text-center'>
              <table className='table table-print-sst-noborder'>
                <tbody>
                    <tr>
                        <td style={{width:'70%'}} className='p-2 text-center'></td>
                        <td style={{width:'30%'}} className='p-2 text-center'>ลงชื่อ_____________________ผู้รับรถ</td>
                    </tr>
                    <tr>
                        <td className='p-2 text-center'></td>
                        <td className='p-2 text-center'>(__________________________)</td>
                    </tr>
                    <tr>
                        <td className='p-2 text-center'></td>
                        <td className='p-2 text-center'>วันที่_______________________</td>
                    </tr>
                </tbody>
              </table>  
            </div>          
    )
  }

  renderSignature() {
    return(
        <div className='text-center'>
            <table className='table table-print-sst-noborder'>
                <tbody>
                    <tr>
                        <td style={{width:'30%'}} className='p-2 text-left'>ลงชื่อผู้ตรวจ ช่างเคาะ</td>
                        <td style={{width:'70%',borderBottom:'1px solid #111'}} className='p-2'></td>
                    </tr>
                    <tr>
                        <td className='text-left p-2'>ลงชื่อผู้ตรวจ ช่างสี</td>
                        <td style={{borderBottom:'1px solid #111'}} className='p-2'></td>
                    </tr>
                    <tr>
                        <td className='text-left p-2'>ลงชื่อผู้ตรวจ ช่างประกอบ</td>
                        <td style={{borderBottom:'1px solid #111'}} className='p-2'></td>
                    </tr>
                    <tr>
                        <td className='text-left p-2'>ลงชื่อผู้ตรวจ ช่างช่วงล่าง</td>
                        <td style={{borderBottom:'1px solid #111'}} className='p-2'></td>
                    </tr>
                    <tr>
                        <td className='text-left p-2'>ลงชื่อผู้ตรวจ ช่างทั่วไป</td>
                        <td style={{borderBottom:'1px solid #111'}} className='p-2'></td>
                    </tr>
                </tbody>
            </table> 
        </div>     
    )
  }

  renderCheckList() {
    let {checkList,checkList2} = this.state.data.related_detail
    return(
        <div style={{display:'flex'}}>
          <div style={{width:'50%'}}>
            <table className='table table-print-sst'>
              <tbody>
                <tr>
                  <td className='p-2 br-t-none br-l-none br-b-none'><br/></td>
                  <td style={{width:'80px'}} className='p-2 text-center'>ดี</td>
                  <td style={{width:'80px'}} className='p-2 text-center'>ไม่ดี</td>
                </tr>
                {
                  checkList.map((item,index)=>{
                    return(
                      <tr key={index}>
                        <td className='p-2 br-t-none br-l-none br-b-none'>{item.label}</td>    
                        <td style={{verticalAlign:'middle'}} className='p-2 text-center line-height-0-5' onClick={this.oncheckListClick.bind(this,index,true)}>{item.value?<FontAwesome style={{fontSize:'16px'}} name='check' />:<br/>}</td>
                        <td style={{verticalAlign:'middle'}} className='p-2 text-center line-height-0-5' onClick={this.oncheckListClick.bind(this,index,false)}>{item.value==false?<FontAwesome style={{fontSize:'16px'}} name='check' />:item.value==''?<br/>:<br/>}</td>
                      </tr>        
                    )  
                  })     
                }
                <tr>
                  <td className='p-2 br-t-none br-l-none br-b-none'><br/></td>
                  <td className='p-2 text-center'><br/></td>
                  <td className='p-2 text-center'><br/></td>
                </tr>
                <tr>
                  <td className='p-2 br-t-none br-l-none br-b-none'><br/></td>
                  <td className='p-2 text-center'><br/></td>
                  <td className='p-2 text-center'><br/></td>
                </tr>
              </tbody>    
            </table>    
          </div>
          <div style={{width:'50%'}}>
            <table className='table table-print-sst'>
              <tbody>
                <tr>
                  <td className='p-2 br-t-none br-l-none br-b-none'><br/></td>
                  <td style={{width:'80px'}} className='p-2 text-center'>ดี</td>
                  <td style={{width:'80px'}} className='p-2 text-center'>ไม่ดี</td>
                </tr>
                {
                  checkList2.map((item,index)=>{
                    return(
                      <tr key={index}>
                        <td className='p-2 br-t-none br-l-none br-b-none'>{item.label}</td>    
                        <td style={{verticalAlign:'middle'}} className='p-2 text-center line-height-0-5' onClick={this.oncheckListClick2.bind(this,index,true)}>{item.value?<FontAwesome style={{fontSize:'16px'}} name='check' />:<br/>}</td>
                        <td style={{verticalAlign:'middle'}} className='p-2 text-center line-height-0-5' onClick={this.oncheckListClick2.bind(this,index,false)}>{item.value==false?<FontAwesome style={{fontSize:'16px'}} name='check' />:item.value==''?<br/>:<br/>}</td>
                      </tr>        
                    )  
                  })     
                }
              </tbody>    
            </table>    
          </div>
        </div>
    )
  }

  renderText() {
      let {data} = this.state
      return(
          <div>
              <div className='font-print-20' style={{textIndent:'50px',lineHeight:'1.2'}}>
                ข้าพเจ้า <span className='dot-1' style={{borderBottom:'2px dotted #111',width:'35%',display:'inline-block'}}>{data.delivering!=undefined&&data.delivering.delivering_name!=''?data.delivering.delivering_name:<br/>}</span> ซึ่งเป็นเจ้าของรถหรือผู้ขับขี่รถยี่ห้อ <span className='dot-2' style={{borderBottom:'2px dotted #111',width:'25%',display:'inline-block'}}>{data.car!=undefined&&data.car.brand!=''&&data.car.model!=''?data.car.brand+' '+data.car.model:<br/>}</span><br/>
                หมายเลขทะเบียน <span className='dot-3' style={{borderBottom:'2px dotted #111',width:'52%',display:'inline-block'}}>{data.car!=undefined&&data.car.car_registration_no!=''?data.car.car_registration_no:<br/>}</span >ที่ได้รับอุบัติเหตูและได้รับรถดังกล่าวมาจัดซ่อมที่<br/>
                {data.company_name!=undefined&&data.company_name!=''?data.company_name:'-'} ตามใบสั่งซ่อมของ {data.insurer_name!=undefined&&data.insurer_name!=''?data.insurer_name:'-'} และข้าพเจ้าได้ตรวจสอบรายการ <br/>
                ซ่อมสีและเปลี่ยนอะไหล่ตามรายการจัดซ่อมว่าถูกต้องทุกอย่างและเป็นที่เรียบร้อยทุกประการ
              </div>
              <div className='font-print-20' style={{textIndent:'50px'}}>
                ข้าพเจ้าขอรับรองว่าจะไม่เรียกร้องสิทธิ์ใดๆ ทั้งสิ้นจาก {data.company_name!=undefined&&data.company_name!=''?data.company_name:'-'} รวมถึงบริษัทประกัน ดังกล่าวอีกต่อไปจึงขอลงลายมือไว้เป็นหลักฐาน  
              </div>  
          </div>
      )
  }

  renderBody() {
    let {data} = this.state
    return(
      <div>
        <table className='table table-print-sst-noborder'>
          <tbody>
            <tr>
              <td className='p-2' style={{width:'200px'}}>ชื่อลูกค้า</td>
              <td className='p-2' style={{width:'500px',borderBottom:'1px solid #111'}}>{data.delivering!=undefined?data.delivering.delivering_name:''}</td>
              <td className='p-2' style={{width:'200px'}}>เบอร์โทร</td>
              <td className='p-2' style={{width:'500px',borderBottom:'1px solid #111'}}>{data.delivering!=undefined?data.delivering.tel:''}</td>
            </tr>
            <tr>
              <td className='p-2'>สถานที่ติดต่อ</td>
              <td className='p-2' colSpan={3} style={{borderBottom:'1px solid #111'}}>{data.delivering!=undefined?data.delivering.address:''}</td>
            </tr>
          </tbody>    
        </table>
        <div><h3 style={{marginBottom:'0',marginTop:'0'}}>โปรดตรวจเช็คสภาพรถตามความจริงทุกข้อก่อนปล่อยรถ</h3></div>
        {this.renderCheckList()}
        {this.renderText()}
        <br/>
        {this.renderSignature()}
        {this.renderSignature2()}
      </div>
    )      
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} />)
    else
      return ('')
  }

  renderComponentPage() {
      let {data} = this.state
      return(
        <div className='font-print'>
          <div>
	        <header>
	          <h2 className="text-right">{this.props.title}</h2>
	        </header>  
	        <article className={"article-company "+data.logo_class}>
	          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
	            {this.renderLogoUrl(data.logo_url)}
	          </div>
	          <section className="font-16" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
	            <strong>
	              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>           
	              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
	              <p style={{lineHeight:'0.7'}}>เลขประจำตัวผู้เสียภาษีอากร {data.company_tax} โทร. {data.company_tel}</p>              
	            </strong>
	          </section>
	        </article>
	        {this.renderBody()}
	      </div>
	    </div>
      )
  }

  render() {
    let {loading} = this.state  
    return(
      <div>
        <PrintPreview
            loading={loading}
            leftBarTitle={'ใบตรวจสภาพรถซ่อม'}
        >
            {this.renderComponentPage()}
        </PrintPreview>
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }
}  

PrintSSTWorkQCDoc.defaultProps = {
  title: 'ใบตรวจสภาพรถซ่อม',
  dn: 'sstworkqcdoc'
}

export default PrintSSTWorkQCDoc;


// WEBPACK FOOTER //
// ./src/view/print/sst/PrintSSTWorkQCDoc.js